import { memo } from 'react';

import { Root } from './CellWarningIndicator.styles';
import { CellWarningIndicatorProps } from './CellWarningIndicator.types';

export const CellWarningIndicator = memo<CellWarningIndicatorProps>((props) => {
    const { level } = props;

    return <Root $level={level} />;
});

CellWarningIndicator.displayName = 'CellWarningIndicator';
